import React from "react";

export default function DashedLine() {
  return (
    <div
      style={{
        width: "100%",
        borderStyle: "dashed",
        height: 1,
        borderColor: "grey",
        borderBottomWidth: 1,
        padding: 2,
      }}
    />
  );
}
